/**
 * View Session Utility
 *
 * Manages a persistent session ID for tracking video views.
 * This allows us to count unique views even for anonymous users.
 */

const SESSION_KEY = 'exercise-toolbox-view-session'

/**
 * Gets or creates a unique session ID for view tracking.
 * The session ID persists in localStorage until cleared.
 */
export function getViewSessionId(): string {
  let sessionId = localStorage.getItem(SESSION_KEY)

  if (!sessionId) {
    sessionId = crypto.randomUUID()
    localStorage.setItem(SESSION_KEY, sessionId)
  }

  return sessionId
}
